<template>
  <div class="section-category section-full">
    <div
      v-if="summary.bills"
      id="shift-report-printable-area"
      ref="printArea"
      class="section-cashcalc px-2"
    >
      <h2 class="ttl2 popup-header" v-translate>shift report</h2>
      <div class="top-info">
        <table>
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <translate>Staff Name</translate>:
                  </td>
                  <td>
                    <b>{{ user.firstName + ' ' + user.lastName }} (# {{ user.ref }})</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <translate>Shift</translate>:
                  </td>
                  <td>
                    <b>{{ summary.name }}</b>
                  </td>
                </tr>
              </table>
            </td>
            <td>
              <table>
                <tr>
                  <td>
                    <translate>Location</translate>:
                  </td>
                  <td>
                    <b>{{ user.location.name }}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <translate>Station</translate>:
                  </td>
                  <td>
                    <b>{{ user.station.name }}</b>
                  </td>
                </tr>
              </table>
            </td>
            <td>
              <table>
                <tr>
                  <td>
                    <translate>Start at</translate>:
                  </td>
                  <td>
                    <b>{{ summary.startTime }}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    <translate>End at</translate>:
                  </td>
                  <td>
                    <b>{{ $dayjs().format('DD/MM/YYYY - HH:mm') }}</b>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <table class="table table-border-outline">
            <thead class="thead-light">
            <tr class="text-uppercase">
              <th 
                class="text-left" 
                v-translate
                style="width: 200px;"
              >bill type</th>
              <th v-translate>amount</th>
              <th v-translate>cash</th>
              <th v-translate>credit</th>
              <th v-translate>other</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td class="text-left"><span v-translate>Close</span> ({{ summary.bills[1].count }})</td>
              <td>{{ summary.bills[1].amount | currency }}</td>
              <td>{{ summary.bills[1].cash | currency }}</td>
              <td>{{ summary.bills[1].card | currency }}</td>
              <td>{{ summary.bills[1].other | currency }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left"> <span v-translate>Void</span> ({{ summary.bills[2].count }})</td>
              <td>{{ summary.bills[2].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            <tr class="border-bottom">
              <td class="text-left">
                <span v-translate>Open</span> ({{ summary.bills[0].count }})
              </td>
              <td>{{ summary.bills[0].amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            <tr 
              v-if="openBillInShifts.length > 1"
              v-for="shift in openBillInShifts"
              class="border-bottom">
              <td class="text-left">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ shift.namePdf }} ({{ shift.count }})</td>
              <td>{{ shift.amount | currency }}</td>
              <td>--</td>
              <td>--</td>
              <td>--</td>
            </tr>
            
            </tbody>
          </table>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>tax / charges</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(value, charge) in summary.chargeData">
                <td>{{ charge }}</td>
                <td>{{ value | currency(true) }}</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>do payment</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, groupIndex) in tablePayment">
                <tr
                  @click="group.open = !group.open"
                  :class="{ opened: group.open == true }"
                  class="tr-parent"
                >
                  <td>
                    <span class="icon-expanded"></span>
                    <span>{{ group.name }} ({{ group.payments.length }})</span>
                  </td>
                  <td>{{ group.total | currency }}</td>
                </tr>
                <tr
                  v-show="group.open"
                  v-for="(payment, paymentIndex) in group.payments"
                  class="tr-child"
                >
                  <template>
                    <td>{{ payment.expenseCategoryName }} - {{ payment.note }}</td>
                    <td>{{ payment.amount | currency }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
          <table class="table table-border-outline do-payment-table" style="table-layout: auto;">
            <thead class="thead-light">
              <tr class="text-uppercase">
                <th class="text-left" v-translate>pay commission</th>
                <th v-translate>amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="commission in tableCommission">
                <tr
                  @click="commission.open = !commission.open"
                  :class="{ opened: commission.open == true }"
                  class="tr-parent"
                >
                  <td>
                    <span class="icon-expanded"></span>
                    <span>{{ commission.name }} ({{ commission.payments.length }})</span>
                  </td>
                  <td>{{ commission.total | currency(true) }}</td>
                </tr>
                <tr v-show="commission.open" v-for="com in commission.payments" class="tr-child">
                  <template>
                    <td>
                      <translate>Staff</translate>
                      #{{ com.note }}
                    </td>
                    <td>{{ com.amount | currency(true) }}</td>
                  </template>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
        <div class="col-sm-6">
          <table class="table table-shift-report">
            <tbody>
              <tr>
                <td v-translate>Start shift cash</td>
                <td>{{ summary.startDrawerCash | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Received Cash</td>
                <td>{{ summary.overall['Received cash'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Change</td>
                <td>{{ summary.overall['Change'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Pay commission</td>
                <td>{{ summary.overall['Commission paid'] | currency(true) }}</td>
              </tr>
              <tr>
                <td v-translate>Do payment (money-in)</td>
                <td>{{ summary.overall['Payments(money-in)'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Do payment (money-out)</td>
                <td>{{ summary.overall['Payments(money-out)'] | currency }}</td>
              </tr>
              <tr>
                <td v-translate>Cash in drawer (counted)</td>
                <td>{{ summary.overall['Cash in drawer(counted)'] | currency }}</td>
              </tr>
              <tr class="border-top">
                <td v-translate>Cash in drawer (expected)</td>
                <td>{{ summary.overall['Cash in drawer(expected)'] | currency }}</td>
              </tr>
              <tr class="border-top border-bottom">
                <td>
                  <strong v-translate>Different</strong>
                </td>
                <td>
                  <strong>{{ summary.overall.Different > 0 ? '+' : '' }}{{ summary.overall.Different | currency }}</strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="btns-footer">
      <button class="btn btn-btn" @click="handleConfirm" v-translate>print</button>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import ShiftService from "@/services/ShiftService";
import { UPDATE_SHIFT, SET_SHIFT_CURRENT_ACTION, SET_MESSAGE_MODAL } from "@/store/mutation-types";

export default {
  name: 'ShiftReport',
  data() {
    return {
      tablePayment: [],
      tableCommission: [],
      tableBill: [],
      shift: { name: '', startDrawerCash: 0 },
      summary: {},
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    openBillInShifts() {
      const openBillShifts = [];
      for (const property in this.summary.bills) {
        if(property.indexOf('s') !== -1) {
          openBillShifts.push(this.summary.bills[property]);
        }
      }
      return openBillShifts;
    },
    ...mapGetters(['total']),
  },
  methods: {
    async handleConfirm() {
      
      const report = await this.$store.dispatch('createPdf', {
        element: document.getElementById('shift-report-printable-area'),
        reportType: 'shift',
        startTime: this.shift.startTime,
      });
      const data = await ShiftService.end({
        endDrawerCash: this.total,
        pdf: report.file,
        message: report.message,
        fileName: report.name,
      });
      if (data && !data.error) {
        await this.$store.dispatch('print', data);
        await report.pdf.save(report.name, { returnPromise: true });
        this.$store.commit(UPDATE_SHIFT, false);
        this.$store.commit(SET_SHIFT_CURRENT_ACTION, "");
        this.$router.push({ name: "order" });
      } else {
        this.$store.commit(SET_MESSAGE_MODAL, data);
      }
    },
  },
  async created() {
    const result = await ShiftService.quickInfo(this.total);
    if (result) {
      this.summary = result;
      this.tablePayment = [
        {
          name: this.$gettext('Money-in'),
          payments: this.summary.moneyIns,
          total: this.summary.moneyIns.reduce(
            (sum, payment) => sum + payment.amount,
            0,
          ),
          open: true,
        },
        {
          name: this.$gettext('Money-out'),
          payments: this.summary.moneyOuts,
          total: this.summary.moneyOuts.reduce(
            (sum, payment) => sum + payment.amount,
            0,
          ),
          open: true,
        },
      ];
      this.tableCommission = [
        {
          name: this.$gettext('Commission'),
          payments: this.summary.payCommissions,
          total: this.summary.payCommissions.reduce(
            (sum, payment) => sum + payment.amount,
            0,
          ),
          open: true,
        },
      ];
    }
  },
};
</script>

<style scoped>
tr.border-top.border-bottom td {
  color: #f00;
}
</style>
